<template>
    <div class="page--add_column">
        <div class="item" v-if="action == 'View' || action == 'List'">{{data[field.key]}}</div>
        <div v-else>
            <div v-for="(n,index) in session" :key="index">
                <div>{{$t("field.general.session", {session : (index+1)})}}</div>
                <AddColumn v-if="index==0" v-model="item[index]" :key="key[index]" @input="changeDataOne" :action="checkType(index)" :data="item[index]" :field="{param:{disable_one:true,column:[{key:'cash',is_show:1},{key:'point',is_show:1},{key:'id'}]}}"/>

                <AddColumn v-else v-model="item[index]" :key="key[index]" @input="changeData" :action="checkType(index)" :data="item[index]" :field="{param:{disable_one:true,column:[{key:'cash',is_show:1},{key:'point',is_show:1},{key:'id'}]}}"/>
            </div>
        </div>
    </div>
</template>

<script>
import AddColumn from "@/views/custom/edit/AddColumn";

export default {
    props: ['data', 'field', 'k', 'action'],
    components: {
        AddColumn
    },
    async created() {
        let id=this.$route.params.id;
        if(this.data.price_scheme_id){
            id=this.data.price_scheme_id;
        }
        let s = 0;
        let c = 0;
        try {
            s = parseInt(this.data?.maxChargingUnit);
            if(!isNaN(s)){
                this.session=s;
                for(let x=0;x<this.session;x++){
                    this.key[x]=0;
                    this.item[x]=[];
                }
            }
        } catch (error) {}
        
        try {
            c = parseInt(this.data?.fee);
            if(!isNaN(c)){
                this.cash=c;
            }
        } catch (error) {
            
        }

        await this.init(id);
        
        let _this = this;
        this.item.map((r,i)=>{
            let cash=(i+1)*_this.cash;
            let d=r[0];
            if(d){
                d.point=0;
                d.cash=cash;
            }
            else {
                this.item[i].push({point:0, cash:cash});
            }
            
        });
        
        // for(let i=0;i<this.session;i++){
        //     let cash=(i+1)*this.cash;
        //     let obj={'point':0,'cash':cash};
        //     if(this.item[i]){
        //         if(this.item[i][0])
        //         this.item[i][0]=obj;
        //     }
        //     else {
        //         this.item[i]=[];
        //         this.item[i].push(obj);
        //     }
        // }

        this.refresh(0);
    },
    async beforeMount() {
        
    },
    methods: {
        async init(id){
            var _this = this;
            await this.$axios.get('/price_scheme_detail/'+id, {
                params: {
                size: 99999,
                page: 0,
                trash: 0,
                    enable_flag: 1
                }
            }).then(res=>{
                console.log("res",res);
                let data = res.data;
                console.log("data",data);
                data.map(r=>{
                    let i = r.session-1;
                    if(_this.item[i]){
                        _this.item[i].push({point:r.point, cash:r.cash, id:r.id});
                    }
                })
                return true;
            }).catch(err=>{ return false; });
        },
        changeDataOne(){
            if(this.data?.type=='Fixed'){
                let s=this.session;
                let _this=this;
                this.item.map((r,index)=>{
                    if(index!=0){
                        r.map(row=>{
                            row.deleted=1;
                        })
                    }
                })
                this.item[0].map((r,index)=>{
                    
                    for(let i=1;i<s;i++){
                        let n=i+1;
                        if(!_this.item[i][index]){
                            _this.item[i][index] = {id:"",cash:"",point:"",deleted:0};
                        }
                        let d = _this.item[i][index];
                        let cash = r.cash*n;
                        let point = r.point*n;

                        if(!isNaN(cash)){
                            d.cash=cash;
                        }
                        if(!isNaN(point)){
                            d.point=point;
                        }
                        d.deleted=r.deleted;
                    }
                })
                this.refresh(1);
            }
            this.changeData();
        },
        refresh(index){
            for(let x=index;x<this.session;x++){
                this.key[x]++;
            }
            this.$forceUpdate();
        },
        changeData(){
            let arr = [];
            this.item.map((r,i)=>{
                r.map(item=>{
                    item.session=i+1;
                    arr.push(item);
                })
            })
            this.$emit("input", arr);
            // this.$forceUpdate();
        },
        checkType(index){
            if(index) {
                if(this.data?.type=='Fixed'){
                    return 'View';
                }
            }
            return 'Edit';
            
        }
    },
    computed: {
        
    },
    data() {
        return {
            item:[],
            session:0,
            cash:0,
            key:[]
        }
    }
}
</script>

<style lang="scss">
    .page--add_column {
        .add_column_row{

        }
    }
</style>